import { getLoggedInUser, putUserpasswordToDb, putUserToDb } from "@/api/user.ts";
import { RouteNames } from "@/router/routes.ts";
import { NewUser, User } from "@/types/base-model.ts";
import { defineStore } from "pinia";
import { useOnceJwtAuthToken } from "@movinglayers/signing";
import { ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useAppLifecycleStore } from "./app-lifecycle.ts";
import { useStorageStore } from "./storage.ts";

export const useUserStore = defineStore("user", () => {

    const user = ref<User | null>(null);
    const { tokenStorage } = toRefs(useStorageStore());
    const { deleteJwt, isAuthenticated, saveJwt, checkAuthenticated, loadJwt } = useOnceJwtAuthToken(tokenStorage);
    const lifecycleStore = useAppLifecycleStore();
    const router = useRouter();

    const fetchMe = async () => {
        const userRes = await getLoggedInUser();
        user.value = userRes.data;
    };

    const logoutUser = () => {
        deleteJwt();
        user.value = null;
        lifecycleStore.reset();
        router.push({ name: RouteNames.LOGIN });
    };

    const updateUser = async (data: NewUser) => {
        // not used atm, not adding monitoring
        try {
            const response = await putUserToDb(data);
            fetchMe();
            return response;
        } catch (error: any) {
            if (error.status === 'Network Error') {
                return { status: 0, message: error.status };
            } else {
                return error.response.data.error;
            }
        }

    };

    const updateUserpw = async (docId: string, oldpw: string, newpw: string) => {
        // not used atm, not adding monitoring
        const pwdata = {
            userDocId: docId,
            currentPassword: oldpw,
            newPassword: newpw
        };
        try {
            const response = await putUserpasswordToDb(pwdata);
            return response;
        } catch (error: any) {
            if (error.status === 'Network Error') {
                return { status: 0, message: error.status };
            } else {
                return error.response.data.error;
            }
        }
    };

    return {
        user,
        saveJwt,
        loadJwt,
        fetchMe,
        logoutUser,
        updateUser,
        updateUserpw,
        isAuthenticated,
        checkAuthenticated
    };
});